export default __webpack_public_path__ + "static/media/BIO.b8b0ee1c.PDF";